import { BasketService } from "@/generated/services/BasketService";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface AddToBasketPayload {
  memberId: number;
  items: {
    offer_id: number;
    retailer_id: number;
  }[];
}

interface RemoveFromBasketPayload {
  memberId: number;
  rewardId: number;
}

export function useAddToBasket() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: AddToBasketPayload) => {
      const { memberId, items } = payload;
      return await BasketService.postMembersBasket(memberId, items);
    },
    onSuccess: async (_data, variables) => {
      // Invalidate and refetch basket after adding
      await queryClient.invalidateQueries({
        queryKey: ["basket", variables.memberId],
      });
    },
  });
}

export function useRemoveFromBasket() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: RemoveFromBasketPayload) => {
      const { memberId, rewardId } = payload;
      return await BasketService.deleteMembersBasket(memberId, rewardId);
    },
    onSuccess: async (_data, variables) => {
      // Invalidate and refetch basket after removal
      await queryClient.invalidateQueries({
        queryKey: ["basket", variables.memberId],
      });
    },
  });
}

export function useClearBasket() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { memberId: number; rewardId: number }) => {
      const { memberId, rewardId } = payload;
      return await BasketService.patchMembersBasketClear(memberId, rewardId);
    },
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["basket", variables.memberId],
      });
    },
  });
}
